import React from "react";
import { Link } from "react-router-dom";
import { DiscardIcon, FoldersIcon } from "assets/images";
import { Button, Tooltip } from "components";

function HeadwallImage(props) {
  const {
    design: { design_image_url, name, model ,updated_at},
    models,
    handleCloseViewDesign,
    handleDownloadDesign,
    handleDeleteDesign,
    handleRequestCADQuote,
    handleMoveToFolder,
    fromFolder,
    handleRemoveFromFolder,
  } = props;

  return (
    <>
      <div className="w-100 d-inline-block text-xl font-extrabold text-black flex items-center justify-between my-5">
        <div className="font-bold text-xl">
          {models[model]} / {name}
        </div>
        <div className="flex items-center justify-end gap-4 px-5">
          <Link
            className="underline font-semibold text-lg"
            onClick={() => handleRequestCADQuote("cad")}
          >
            Request CAD
          </Link>
          <Link
            className="underline font-semibold text-lg"
            onClick={() => handleRequestCADQuote("quote")}
          >
            Request Quotation
          </Link>
          <Link
            className="underline font-semibold text-lg"
            onClick={() => handleRequestCADQuote("both")}
          >
            Both CAD & Quotation
          </Link>
          {fromFolder && (
            <Tooltip
              class_name={"cursor-pointer folder-reverse"}
              icon={FoldersIcon}
              width={48}
              height={48}
              handleClick={handleRemoveFromFolder}
              title={"Remove from Folder"}
            />
          )}
          <Tooltip
            class_name={"cursor-pointer"}
            icon={FoldersIcon}
            width={48}
            height={48}
            handleClick={() => handleMoveToFolder(true)}
            title={"Move to Folder"}
          />
          <Tooltip
            class_name={"cursor-pointer"}
            icon={DiscardIcon}
            width={48}
            height={48}
            handleClick={(e) => handleDeleteDesign(e, "file")}
            title={"Delete Design"}
          />
        </div>
      </div>
      <div className="w-100 imgDesignDiv">
        <img className="" src={design_image_url} alt="...img" />
      </div>
      <div className="flex justify-end">
        <Button
          className="btnTxt mt-2 px-7 py-1 border border-teal-700 text-teal-700  bg-white font-semibold  rounded cursor-pointer "
          text={"Back"}
          handleClick={handleCloseViewDesign}
          type={"button"}
        />
        <Button
          className="login_btn btnTxt  text-white cursor-pointer rounded mt-2 px-5 mx-2"
          text={"Download"}
          handleClick={() => handleDownloadDesign(design_image_url, name,model,updated_at)}
          type={"button"}
        />
      </div>
    </>
  );
}

export default HeadwallImage;
